module.exports = __webpack_public_path__ + "img/college5.2c44c1f2.png";